export function assignPixelToSpacing(spacing = 0): string {
  return `${spacing}px`;
}
